import { useSheets } from 'global/cnr/contexts/useHelpers/useSheets';
import NoData from 'global/components/alerts/NoData';
import UiSaveButtons from 'global/components/buttons/UiSaveButtons';
import { GroupSquares, GroupSquaresContext } from 'global/wrappers/GroupSquares';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import _ from 'lodash';
import { seasonalUpdateTypes } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalDataHelpers';
import { seasonalHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalHelpers';
import { _matchStatusTypes } from 'projectSpecific/sports/helpers/sportsEnums';
import useGoogleSports from 'projectSpecific/sports/useHelpers/useGoogleSports';
import { useSeasonalDataHelpers } from 'projectSpecific/sports/useHelpers/useSeasonalDataHelpers';
import { _allowSportsUpdates } from 'projectSpecific/sports/useHelpers/useSeasonals';
import { useSportsMatches } from 'projectSpecific/sports/useHelpers/useSportsMatches';
import { createContext, useContext, useMemo, useReducer, useState } from 'react';
import { Label } from 'semantic-ui-react';
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { SportsDistrictContext } from '../../cnr/contexts/SportsDistrictContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { sportsDataHandlers, sportsDataInitialState, sportsDataReducer } from '../../cnr/reducers/SportsDataReducer';
import { _fetchModes } from './MatchDataUpdate';
import MatchSquares from './MatchSquares';

export const _mediaModes = {
  results: 'results',
  playoffResults: 'playoffResults',
}

export const _resultModes = {
  ammend: 'ammend',
  backup: 'backup',
  export: 'export',
  media: 'media',
  openExternal: 'openExternal',
  scores: 'scores',
  search: 'search',
}

export const MatchDataUpdateContext = createContext();

const MatchResults = (props) => {

  const { sportsDataMode, fromApp, currentMenuKey } = props

  const { updateMatchesSeasonal_byLevel, updating } = useSeasonalDataHelpers()
  const { getMatches_flat, analyzeMatches, compareMatches, getMatches_dotCkUpdates } = useSportsMatches()
  const { sheets_fns } = useSheets()

  const groupSquaresContext = useContext(GroupSquaresContext)
  const { groupSquares_state, groupSquares_handlers } = groupSquaresContext ?? {}

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainDb } = app_state

  const database_fns = _.get(parentContext, 'fns.database_fns')

  // sportsDistrictContext
  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { sportPermissions } = sportsDistrict_state ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}

  const {
    gameScoringType,
    currentSeason_info,
    links_score,
    matches_info,
    teams_info,
    sportSettings_info,
    sportsShowOptions,
  } = sportsSeason_state ?? {}

  const { useScoringCollection, useScoringCollectionOnly } = sportSettings_info ?? {}
  const { latestSeason, sportsKey } = currentSeason_info ?? {}

  // const { matchDate } = sportsShowOptions ?? {}

  // sportsData
  const init_state = {
    database_fns,
    fn_cls,
    gameScoringType,
    latestSeason,
    links_score,
    mainDb,
    matches_info,
    pathViews,
    sportPermissions,
    sportsKey,
    teams: teams_info && teams_info.teams,
    useScoringCollection,
    useScoringCollectionOnly,
  }

  const [sportsData_state, sportsData_dispatch] = useReducer(sportsDataReducer, init_state, sportsDataInitialState)
  // const sportsData_handlers = sportsDataHandlers(sportsData_dispatch, sportsData_state)

  const [updates_app, setUpdates_app] = useState()
  const [updates_app_dot, setUpdates_app_dot] = useState()

  const [matchResultsInfo, setMatchResultsInfo] = useState()
  const [fetchMode, setFetchMode] = useState()

  const forPlayoffs = (fm) => {
    switch (fm) {
      case _fetchModes.playoffResults:
      case _fetchModes.mediaPlayoffResults:
        return true;
      default:
        return false
    }
  }

  const { filterType } = sportsData_state ?? {}

  const matches_flat = useMemo(() => {
    if (!matches_info) return;
    return getMatches_flat({ matches_info })
  }, [matches_info])

  const { handleGet_gsMatches, fetching } = useGoogleSports({
    currentMenuKey,
    sportsDataMode,
    gameScoringType,
  })

  let btn_prefix = 'Update';

  switch (filterType) {
    case _matchStatusTypes.season:
    case _matchStatusTypes.seasonPlayoff:
      btn_prefix = 'Refresh'
      break;
    default:
      btn_prefix = 'Update'
  }

  const { counts } = matches_flat ?? {}
  const { filtered: filtered_count } = counts ?? {}

  let headerCount;

  if (filtered_count) {
    headerCount = filterType ? _.startCase(filterType) + ' (' + filtered_count + ')' : 'All (' + filtered_count + ')'
  }

  const updateResults = () => {

    const cb = () => {

    }

    const { matchUpdates_dot_mcks } = matchResultsInfo ?? {}
    const _latestSeason = latestSeason

    const { updates_app_dot, updates_grouped } = getMatches_dotCkUpdates({ updates_app })

    const _updateProps = {
      callback: cb,
      dataToUpdate: matchUpdates_dot_mcks,
      forPlayoffs: forPlayoffs(fetchMode),
      pathViews,
      pks: seasonalHelpers.getPks(pathViews, _latestSeason, sportsKey),
      seasonalUpdateType: seasonalUpdateTypes.matchesList,
      sportPermissions,
      useScoringCollection,
      useScoringCollectionOnly,
    }

    console.group('handleUpdate_matches')
    console.log('matchUpdates_dot_mcks', matchUpdates_dot_mcks)
    console.log('updates_app', updates_app)
    console.log('updates_grouped', updates_grouped)
    console.log('updates_app_dot', updates_app_dot)
    console.log('_updateProps', _updateProps)
    console.groupEnd()

    updateMatchesSeasonal_byLevel(_updateProps)

  }
  const header_flex = (caption, count) => <div className='header-flex'>
    <div>{caption}</div>
    <div>
      <Label size='mini'>{count}</Label>
    </div>
  </div>

  const fnCurrentGroup = (cg) => {
    switch (cg.key) {
      case _fetchModes.seasonResults:
      case _fetchModes.playoffResults:
        const { matchUpdates } = matchResultsInfo ?? {}
        if (matchUpdates) {
          const count = matchUpdates ? _.size(matchUpdates) : 0
          const _caption = _.startCase('updatedMatches')
          return <Wrapper
            header={header_flex(_caption, count)}
            content={count > 0 ? <MatchSquares matches={matchUpdates} showChanges={true} fromLookup={true} /> : <NoData fullCaption={'None'} />}
            wrapperType={count > 0 ? wrapperTypes.paddedHeader : wrapperTypes.padded}
            footer={<UiSaveButtons save={{ oc: updateResults }} color={_allowSportsUpdates.matches ? 'green' : 'teal'} />}
            css={{ content: count === 0 ? 'hwcc' : null }}
          ></Wrapper >
        }
        return <div>{cg.key}</div>


      case _fetchModes.pendingPlayoffMatches:

      case _fetchModes.mediaResults:
      case _fetchModes.mediaPlayoffResults:
      case _fetchModes.wpialResults:
        // nothing yet
        break;
    }
    return '???'
  }

  const fnTrigger = (key) => {

    const cb = (_matchResultsInfo) => {

      // const { updates_app } = currentMatchUpdates ?? {}
      const { updates_app: _updates_app } = analyzeMatches({
        matches_gs: _matchResultsInfo?.matches_gs,
        matches_app: matches_info?.matches_combined,
      })

      const { updates_app_dot } = getMatches_dotCkUpdates({ updates_app: _updates_app })

      setMatchResultsInfo(_matchResultsInfo)
      setUpdates_app(_updates_app)
      setUpdates_app_dot(updates_app_dot)

      console.group('trigger')
      console.log('_matchResultsInfo', _matchResultsInfo)
      console.log('updates_app', _updates_app)
      console.log('updates_app_dot', updates_app_dot)
      console.groupEnd()
      setFetchMode(key)
    }

    const cbe = (_matchResultsInfo) => {
      setMatchResultsInfo(null)
      setUpdates_app(null)
      setFetchMode(key)
    }

    // get the matches from google sheets
    const opts = { fetchMode: key, forPlayoffs: forPlayoffs(key) }
    handleGet_gsMatches({ opts, matches_flat, callback: cb, callback_error: cbe })

  }

  const gs = () => <GroupSquares
    menuItems={_fetchModes}
    fnCurrentGroup={fnCurrentGroup}
    fnTrigger={fnTrigger}
    updating={fetching}
    caption={'Results Options'}
    iconItem={'external alternate'}
    noHeader={true}
  />

  return gs()
}

export default MatchResults

